const IECContent = [
  {
    images: ["/assets/img/42.jpg", "/assets/img/43.jpg", "/assets/img/44.jpg"],
  },
];

export default IECContent;
